// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowUpOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowUpOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowUpOutlinedSvg
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
export default React.forwardRef(ArrowUpOutlined);